import { Box, AppBar, Toolbar, Grid, Button, styled } from '@mui/material';
import { WsColors } from 'wisestep-base';

import GlobalLoader from '../../interceptor/useAxiosLoader';
import { logout } from '../../utils/token';

type LayoutProps = {
  children: React.ReactNode;
};

const StyledAppBar = styled(AppBar)({
  backgroundColor: WsColors.White,
});

const NonAuthLayout = ({ children }: LayoutProps) => (
  <>
    <Box sx={{ flexGrow: 1 }}>
      <StyledAppBar position="static">
        <Box height={1}>
          <GlobalLoader />
        </Box>
        <Toolbar variant="dense">
          <Grid container>
            <Grid item xs={12}>
              <Box sx={{ float: 'right' }}>
                <Button color="inherit" onClick={async () => await logout()}>
                  Logout
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Toolbar>
      </StyledAppBar>
    </Box>
    {children}
  </>
);

export default NonAuthLayout;
